export enum ResponseMessageType {
  SUCCESS = 'Success',
  ERROR = 'Error',
}
